<div class="container {{ OBJ_LNG_NAME }} insertEdit">
	<h1 mat-dialog-title *ngIf="aktuell.typ==0">
		{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typnews' | translate:locale.language } }}
		<button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
		<mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
	</h1>
	<h1 mat-dialog-title *ngIf="aktuell.typ==1">
		{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typdokumente' | translate:locale.language } }}
		<button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
		<mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
	</h1>
	<h1 mat-dialog-title *ngIf="aktuell.typ==2">
		{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typvertraege' | translate:locale.language } }}
		<button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
		<mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
	</h1>

	<mat-dialog-content>

		<form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">
				<input matInput [hidden]="true" [(ngModel)]="aktuell.id" name="id" autofocus />

				<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

		        <mat-form-field class="full-width">
		            <textarea class="eintrag_textarea" matInput #inhalt="ngModel" (input)="setSubmit(true)" [(ngModel)]="aktuell.text" name="inhalt"  maxlength="500" [disabled]="dialogrunningajaxcall" required rows="5">
					</textarea>
					<mat-label>{{ OBJ_LNG_NAME+'.texteingabe' | translate:locale.language }}</mat-label>
		            <mat-hint *ngIf="inhalt.errors && (inhalt.dirty || inhalt.touched) && inhalt.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.titel' | translate:locale.language } }}</mat-hint>
		            <mat-hint *ngIf="inhalt.value" align="end">{{ inhalt.value.length }} / 500</mat-hint>
		        </mat-form-field>
<!--		        <mat-card appearance="outlined">-->
<!--		            <mat-card-subtitle>-->
<!--		                {{ 'eintrag.hinweis' | translate:locale.language }}-->
<!--		            </mat-card-subtitle>-->

					<mat-form-field class="full-width">
						<input name="ablaufdatumCtl" matInput [matDatepicker]="ablaufdatumpicker" [min]="curDate()"
							   (click)="ablaufdatumpicker.open()" (dateChange)="setSubmit(true)"
							   [(ngModel)]="aktuell.ablaufdatum">
						<mat-datepicker-toggle matSuffix [for]="ablaufdatumpicker"></mat-datepicker-toggle>
						<mat-datepicker #ablaufdatumpicker></mat-datepicker>
						<mat-label>{{ OBJ_LNG_NAME+'.ablaufdatum' | translate:locale.language }}</mat-label>
					</mat-form-field>

<!--		        </mat-card>-->
<!--		        <mat-card appearance="outlined">-->
<!--		            <mat-card-subtitle>-->
<!--		               {{ OBJ_LNG_NAME+'.kategorie' | translate:locale.language }}-->
<!--		            </mat-card-subtitle>-->
			<mat-form-field class="full-width">
					<mat-select [(ngModel)]="aktuell.kategorie" (valueChange)="setSubmit(true)"
								name="typCtl"
								[disabled]="dialogrunningajaxcall" required>
						<mat-option *ngFor="let kategorie of aktuell.kategorieListe" [value]="kategorie.id">{{ kategorie.bezeichnung }}</mat-option>
					</mat-select>
					<mat-label>{{ OBJ_LNG_NAME+'.kategorie' | translate:locale.language }}</mat-label>
<!--		        </mat-card>-->
			</mat-form-field>

		        <mat-card appearance="outlined" align="end">
		            <mat-card-actions>
		                <button mat-raised-button type="button" color="primary"
		                    (click)="zeigeDateiuploadMaske(false)" [disabled]="dialogrunningajaxcall"><mat-icon>attach_file</mat-icon> {{ 'allgemein.neu' | translate:locale.language:{ typ: 'DATEI.typ' | translate:locale.language } }}
		                </button>
		            </mat-card-actions>
		        </mat-card>
		        <mat-card appearance="outlined" *ngFor="let datei of aktuell.anhang; let i=index" class="eintrag_filecard">
		                <mat-card-subtitle>
		                    {{ datei.name }}
		                </mat-card-subtitle>
		                <mat-card-actions align="end">
		                    <button mat-icon-button (click)="entferneDatei(i);setSubmit(true)" matTooltip="{{ 'allgemein.löschen' | translate:locale.language:{ typ: 'datei.typ' | translate:locale.language } }}"><mat-icon>delete</mat-icon></button>
		                </mat-card-actions>
		        </mat-card>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">

		<button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{ 'allgemein.abbrechen' | translate:locale.language }}</button>
		<button mat-raised-button type="submit" (click)="speichernAendern()" color="primary" [disabled]="!canSubmit || dialogrunningajaxcall">
			<mat-spinner *ngIf="dialogrunningajaxcall" color="primary" mode="indeterminate"></mat-spinner>
			{{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) | translate:locale.language:{ typ: OBJ_LNG_NAME+'.liste' | translate:locale.language } }}
		</button>

	</mat-dialog-actions>

</div>

